module.exports = __webpack_public_path__ + "static/img/id_4reflect.f5fa7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_4reflect.png
// module id = GR4m
// module chunks = 1